const updates = [
  { date: '07.30', content: '热播剧《某某风云》第28集已更新，多源可选，高清流畅' },
  { date: '07.30', content: '院线新片《某某传说》高清版正式上线，画质震撼' },
  { date: '07.29', content: '日剧《东京某某》全季资源已同步，中文字幕完整版' },
  { date: '07.29', content: '热门综艺《某某挑战》最新一期精彩上线' },
  { date: '07.28', content: '动画电影《某某奇缘》国语配音版上线，适合全家观看' },
  { date: '07.28', content: '韩剧《某某恋人》第12集高清中字已更新' },
  { date: '07.27', content: '纪录片《某某中国》全系列上线，深度内容值得一看' },
  { date: '07.27', content: '经典修复版《某某岁月》4K高清版全新上线' },
  { date: '07.26', content: '欧美剧《某某之城》新季首播已同步，多平台资源可选' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            影视资源实时更新动态，不错过任何精彩内容
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pb-6 md:pb-7 last:pb-0 pl-10 md:pl-12">
                <div className="absolute left-3 md:left-4 top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <span className="flex-shrink-0 text-xs md:text-sm font-medium text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md whitespace-nowrap mt-0.5">
                  {item.date}
                </span>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}